import {useMutation, useQueryClient} from '@tanstack/react-query';

import {
  createCurrencyEventSchedule,
  CreateCurrencyEventScheduleParams,
} from '../api';
import {QUERY__CURRENCY_EVENT_SCHEDULES} from '../queryKeys';

export const useCreateCurrencyEventSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateCurrencyEventScheduleParams) =>
      createCurrencyEventSchedule(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__CURRENCY_EVENT_SCHEDULES],
      });
    },
  });
};
